import { SubmitB2bScaleOrderResponseProto } from "@noom/noom-contracts/noom_contracts/backend/scales/scale_order_service";
import { AddressProto } from "@noom/noom-contracts/noom_contracts/billing/address/address";
import { Api } from "@noom/noomscape";

import axios from "axios";

type SubmitB2BScaleOrderParams = {
  accessCode: string;
  shippingAddress: AddressProto;
  accessToken: string;
};

Api.register(
  "scales.orderScale",
  async ({
    accessCode,
    shippingAddress,
    accessToken,
  }: SubmitB2BScaleOrderParams) => {
    const response = await axios({
      baseURL: window.ENV.SERVER_URL,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      method: "POST",
      url: `/users/${accessCode}/scales/submitB2bScaleOrder`,
      urlWithPathParams: "/users/{accessCode}/scales/submitB2bScaleOrder",
      data: { shippingAddress },
    });

    return response.data as SubmitB2bScaleOrderResponseProto;
  },
);
